import React, { FC, useEffect, useRef, useState } from 'react';

import { DESCRIPTION_EDIT_ENUMS } from 'constants/ai-prompt.constants';
import AddIcon from 'components/common/icons/AddIcon';
import { PRIMARY_BLUE, PRIMARY_GREY, WHITE } from 'constants/colours';
import { Button } from 'components/common/buttons';
import AIGenerateIcon from 'components/common/icons/AIGenerateIcon';

interface EditAIDescriptionToolTipProps {
  setShowAIEditDropdown: (val: boolean) => void;
  buttonRef?: any;
  handleEditDescription: (editOptions: string[], editInstruction?: string) => void;
}

/**
 * Tooltip that get renders inside event description editor when event already has description.
 * @param param0
 * @returns
 */
export const EditAIDescriptionToolTip: FC<
  React.PropsWithChildren<EditAIDescriptionToolTipProps>
> = ({ setShowAIEditDropdown, handleEditDescription, buttonRef }) => {
  const newRef = useRef<HTMLDivElement>(null);

  const [editOptions, setEditOptions] = useState<string[]>([]);
  const [editInstruction, setEditInstruction] = useState<string>();

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  });

  const handleOutsideClick = (e: Event): void => {
    if (
      newRef.current &&
      !newRef.current.contains(e.target as HTMLDivElement) &&
      buttonRef?.current &&
      !buttonRef.current.contains(e.target)
    ) {
      setShowAIEditDropdown(false);
    }
  };
  return (
    <div
      ref={newRef}
      className="tw-absolute tw--bottom-[210px] tw--right-[20px] tw-z-50 tw-w-[420px] tw-rounded-lg  tw-border !tw-border-border-grey tw-bg-white  tw-py-3 !tw-font-poppins tw-shadow-[0_0px_17px_-7px_rgba(0,0,0,0.3)]"
    >
      <div className=" tw-flex tw-flex-row tw-flex-wrap tw-gap-2 tw-px-3 ">
        {Object.values(DESCRIPTION_EDIT_ENUMS).map((val) => {
          const selected = editOptions?.includes(val);

          const buttonStyle = selected
            ? '!tw-border-primary-blue !tw-bg-light-blue-badge'
            : '!tw-border-border-grey !tw-bg-background-grey';
          const labelStyle = selected ? 'tw-text-primary-blue' : 'tw-text-primary-grey';
          return (
            <button
              key={val}
              type="button"
              className={`!tw-w-auto !tw-rounded-[8px] !tw-border-[1.5px] !tw-border-solid  ${buttonStyle}`}
              onClick={(): void => {
                const index = editOptions?.indexOf(val);

                if (index === -1) {
                  const temp = [...editOptions];
                  temp.push(val);
                  setEditOptions(temp);
                } else {
                  const temp = [...editOptions];
                  temp.splice(index, 1);

                  setEditOptions(temp);
                }
              }}
            >
              <div className="tw-flex tw-flex-row tw-items-center ">
                <div className="tw-mr-[2px]">
                  <AddIcon color={selected ? PRIMARY_BLUE : PRIMARY_GREY} />
                </div>
                <div className={labelStyle}>{val}</div>
              </div>
            </button>
          );
        })}
      </div>
      <div className=" tw-px-3">
        <textarea
          value={editInstruction}
          onChange={(event: React.ChangeEvent<HTMLTextAreaElement>): void => {
            setEditInstruction(event.target.value);
          }}
          placeholder="For example, make it less cheesy."
          rows={1}
          className="tw-mt-3 tw-w-full tw-resize-none tw-rounded-lg tw-border-solid tw-border-border-grey tw-p-4 focus:tw-outline focus:tw-outline-primary-blue"
        />
      </div>
      <div className="tw-mt-3 tw-h-[1px] tw-w-full tw-bg-light-grey" />

      <div className="tw-mb-4 tw-mt-3 tw-px-3">
        <Button
          onClick={(): void => {
            handleEditDescription(editOptions, editInstruction);
          }}
          style={{
            background: PRIMARY_BLUE,
            borderRadius: '8px',
            width: '100%',
            color: WHITE
          }}
          disabled={editOptions.length === 0 && !editInstruction}
          maxWidth="110px"
          height="40px"
          type="button"
        >
          <div className="tw-ml-2 tw-flex tw-flex-row">
            <div>
              <AIGenerateIcon color={WHITE} />
            </div>
            <div className="tw-ml-1">Generate</div>
          </div>
        </Button>
      </div>
    </div>
  );
};
